import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface Breadcrumb {
  label: string;
  url?: string; // optional, in case you want clickable crumbs
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbServiceService {
  private breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbs.asObservable();

  // Set full breadcrumb list
  setBreadcrumbs(crumbs: Breadcrumb[]) {
    this.breadcrumbs.next(crumbs);
  }

  // Add one more breadcrumb
  addBreadcrumb(crumb: Breadcrumb) {
    const current = this.breadcrumbs.getValue();
    this.breadcrumbs.next([...current, crumb]);
  }

  // Clear all
  clear() {
    this.breadcrumbs.next([]);
  }

  // Get current list
  getCurrentBreadcrumbs(): Breadcrumb[] {
    return this.breadcrumbs.getValue();
  }

  public allLinks: any = {
    Marketplaces: [
      {
        name: 'Marketplaces',
        link: 'marketplaces/marketplaces',
        isPermissionList: true,
        labelForPermission: 'Marketplace:View',
      },
      {
        name: 'Accounts',
        link: 'marketplaces/accounts',
        isPermissionList: true,
        labelForPermission: 'MarketplaceAccount:View',
      },
    ],
  };
}
